export default __webpack_public_path__ + "static/media/bg3.c968e379.jpg";